export const getLinkReplaced = (uri) => {
    const baseUrl = uri.match(/^https:\/\/[^\/]+\/?/)[0];
    const remainingUrl = uri.slice(baseUrl.length);
    let replacedUrl = uri;
    if (window.location.hostname === 'cora-stg-maz.ab-inbev.com') {
        replacedUrl = `https://cora-stg-maz.ab-inbev.com/dlc/coolers/${remainingUrl}`;
    }
    if (window.location.hostname === 'cora-maz.ab-inbev.com') {
        replacedUrl = `https://cora-maz.ab-inbev.com/dlc/coolers/${remainingUrl}`;
    }
    return replacedUrl;
};
//# sourceMappingURL=methods.js.map